import { render, staticRenderFns } from "./QuickChat.vue?vue&type=template&id=5c440e20&scoped=true&"
import script from "./QuickChat.vue?vue&type=script&lang=js&"
export * from "./QuickChat.vue?vue&type=script&lang=js&"
import style0 from "./QuickChat.vue?vue&type=style&index=0&id=5c440e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c440e20",
  null
  
)

export default component.exports